<template>
  <a
    class="btn link tc ttu f3 db db-m w-100 w-100-m w-40-ns w-40-l ba ph4 pv2 ml-auto mr-auto ml0-ns ml-auto-m ml0-l mr4-ns mr-auto-m mr4-l mb5 green b--green br-pill"
    :class="extraClass"
    :href="buttonUrl"
    target="_blank"
    >{{ buttonName }}</a
  >
</template>

<script>
export default {
  name: 'InfoButton',
  props: {
    buttonUrl: String,
    buttonName: String,
    extraClass: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.btn {
  min-width: 110px;

  /* border-width: 2px;
  padding: 4em 1.3em; */

  padding: 3rem 0;
  border-width: 4px;
  font-weight: 300;
  font-size: 3.5rem;
}

a.btn:hover {
  background-color: #00ff00;
  /* font-family: 'Courier New', Courier, monospace; */
  /* font-weight: bolder; */
  /* font-size: 1.51rem; */
  /* font-size: 4.82rem; */
  /* font-weight: 400;
  font-size: 4.5rem; */
  font-weight: 300;
  color: black;
}

@media screen and (min-width: 30em) {
  a.btn {
    max-width: 580px;
    font-size: 4.5rem;
    font-weight: 300;
  }

  a.btn:hover {
    font-weight: 400;
    font-size: 4.5rem;
  }
}

/* @media screen and (max-width: 480px) {
  a.btn,
  a.btn:hover {
    font-size: 2.5rem !important;
  }
} */
</style>
